import { clearAll } from "./localCache";

export async function clearPrivateClientState() {
  await clearAll();
  for (const storage of [window.localStorage, window.sessionStorage]) {
    try {
      Object.keys(storage).filter((key) =>
        /^(crc_triage_|crc_disc_|crc_smart_|crc_portal_|cr_chat_|cr_invoice_generator_state)/.test(key)
      ).forEach((key) => storage.removeItem(key));
    } catch { /* Browsers may disable storage. */ }
  }
  if ("caches" in window) {
    try {
      await Promise.all((await caches.keys()).map(async (name) => {
        if (name.endsWith("-api-ro")) return caches.delete(name);
        const cache = await caches.open(name);
        await Promise.all((await cache.keys()).filter((request) => new URL(request.url).pathname.startsWith("/api/")).map((request) => cache.delete(request)));
      }));
    } catch { /* Private APIs also bypass caching in the new worker. */ }
  }
}